<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Upload Image
      </div>
      <button
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div class="upload-image-container">
        <form
          v-if="!imagePreview"
          class="dropbox-form"
          enctype="multipart/form-data"
        >
          <div class="dropbox-container">
            <input
              ref="imageRef"
              type="file"
              class="db-input"
              accept="image/*"
              @change="selectedImage"
            >
            <div class="db-header">
              <div>
                Drag your file
              </div>
              <div>
                or
              </div>
              <div>
                click to browse
              </div>
            </div>
          </div>
        </form>
        <img
          v-else
          class="image-preview"
          :src="imagePreview"
        >
      </div>
      <ProcessOverlay
        :show="uploadingImage"
        text="Uploading Image"
        overlayClass="ac-overlay"
      />
    </div>
    <div class="ac-footer-container">
      <button
        type="button"
        :disabled="!imagePreview"
        class="ac-form-button"
        @click="uploadImage()"
      >
        Update
      </button>
    </div>
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'UploadImage',
  components: {
    ProcessOverlay,
  },
  mixins: [customerDetailMixin],
  data() {
    return {
      imagePreview: '',
    };
  },
  methods: {
    selectedImage() {
      const image = this.$refs.imageRef.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.imagePreview = e.target.result;
      };
      this.$store.dispatch('selectedHvacImage', {
        image,
      });
    },
  },
};
</script>
